import React from 'react'
import congrats from '../../../assets/images/moodcond/6-9.png'
import warning from '../../../assets/images/moodcond/3-6.png'
import alert from '../../../assets/images/moodcond/9-12.png'

const MoodConditions = ({ prop }) => {


   

    const mood = [
        {
            heading: 'Warning!',
            time: '0-6',
            des: ' Your sleep averages less than 6 hours, which can affect cognitive function and health. Adjust bedtime routine for better quality and duration.',
            thumbnail: warning,
            class: "danger"
        },
        {
            heading: 'Congratulations!',
            time: '6-9',
            des: ' Your sleep time is great, averaging 6-9 hours, which is optimal for health. Keep it up with consistent patterns for well-being.',
            thumbnail: congrats,
            class: "success"
        },
        {
            heading: 'Warning!',
            time: '9-12',
            des: 'Your sleep exceeds 9 hours, which can lead to lethargy. Aim for consistency in your sleep schedule for better quality and refreshed mornings.',
            thumbnail: alert,
            class: "danger"
        }
    ]

    return (
        <>
            <div className="moodconditions p-0">
                <div className="row align-items-center">
                    <div className="col-4">
                        <img src={mood[prop]?.thumbnail} className='img-fluid' alt="" />
                    </div>
                    <div className="col-8 ps-0">
                        <h6 className={`text-${mood[prop]?.class}`}>{mood[prop]?.heading}</h6>
                        <p className='font-xss text-left m-0'>{mood[prop]?.des}</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MoodConditions
